import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as form } from 'redux-form';

import activity from './activity';
import app from './app';
import auth from './auth';
import blogs from './blogs';
import blogPost from './blogPost';
import cams from './cams';
import comments from './comments';
import favoriteInfo from './favoriteInfo';
import favoritesAndRatings from './favoritesAndRatings';
import galleries from './galleries';
import gallery from './gallery';
import galleryPermissions from './galleryPermissions';
import itemCounts from './itemCounts';
import leaderboard from './leaderboard';
import marketing from './marketing';
import model from './model';
import models from './models';
import movie from './movie';
import notifications from './notifications';
import photographer from './photographer';
import photographers from './photographers';
import playedMovies from './playedMovies';
import ratingInfo from './ratingInfo';
import searchResults from './searchResults';
import settings from './settings';
import site from './site';
import siteNotifications from './siteNotifications';
import sites from './sites';
import splash from './splash';
import tags from './tags';
import theme from './theme';
import updates from './updates';
import userComments from './userComments';

// Please keep alphabetized
const rootReducer = combineReducers({
  activity,
  app,
  auth,
  blogs,
  blogPost,
  cams,
  comments,
  favoriteInfo,
  favoritesAndRatings,
  form,
  galleries,
  gallery,
  galleryPermissions,
  itemCounts,
  leaderboard,
  marketing,
  model,
  models,
  movie,
  notifications,
  photographer,
  photographers,
  playedMovies,
  ratingInfo,
  routing,
  searchResults,
  settings,
  site,
  siteNotifications,
  sites,
  splash,
  tags,
  theme,
  updates,
  userComments,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
